export const FeaturedData = [
  {
    Id: 1,
    img: 'faq/1.jpg',
    date: '15 April 2022',
    writer: 'Admin',
    hits: '0',
    short_description: [' Web Designing course belongs to the field of Computer Science and IT. It enables students to learn.'],
    rvalue: 4,
    title: 'Web Design',
  },
  {
    Id: 2,
    img: 'faq/2.jpg',
    date: '15 May 2022',
    writer: 'Admin',
    hits: '0',
    short_description: ['This course is designed to start you on a path toward future studies in web development and design.'],
    rvalue: 5,
    title: 'Web Development',
  },
  {
    Id: 3,
    img: 'faq/3.jpg',
    date: '15 June 2022',
    writer: 'Admin',
    hits: '0',
    short_description: ['User interface design (UI) is the design for machines and software, such as mobile devices, computers.'],
    rvalue: 4,
    title: 'UI Design',
  },
  {
    Id: 4,
    img: 'faq/4.jpg',
    date: '15 July 2022',
    writer: 'Admin',
    hits: '0',
    short_description: ['A Web Designing course belongs to the field of Computer Science and IT. It enables students to learn.'],
    rvalue: 3,
    title: 'Tailwind Design',
  },
];
